// swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Mousewheel } from 'swiper/modules';
// parallax
import { Parallax } from "../../features/prallax/parallax";
// toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toastOptions } from "../../features/toast/toast";
// cookie
// @ts-ignore
import Cookies from 'js-cookie';
// navigate
import { routes } from "../../features/routes/route";
import { useMutation } from '@tanstack/react-query';
import { sendOtp } from '../../services/auth/otp/sendOtp';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { SetUserRef } from '../../services/auth/userInfo/refral';
import { errorText } from '../../features/errorText/errorText';

const Slider = (props: any) => {
    const navigate = useNavigate();
    const otpMutation = useMutation({
        mutationFn: sendOtp,
        onSuccess: data => {
            // toast.success('پیامک ارسال شد...', toastOptions)
            window.open('https://client.irantarakonesh.ir/login', '_self')
        },
        onError: (error: any) => {
            toast.error(error?.response?.data?.message, toastOptions);
        }
    });
    const authUser = (idName: string) => {
        let regex = new RegExp(/(^09[0-9]{9}$)|(^\u06F0\u06F9[\u06F0-\u06F9]{9})$/);
        let result = regex.test((document.getElementById(idName) as HTMLInputElement)!.value);
        if (!result) {
            document.getElementById('signup-btn')!.innerHTML = 'نا موفق !'
            toast.error('شماره تلفن خود را به درستی وارد نمایید', toastOptions);
        } else {
            document.getElementById('signup-btn')!.innerHTML = 'تبریک...';
            Cookies.set('auth', true)
            // @ts-ignore
            Cookies.set('mobileNumber', document.getElementById('telephone')?.value)
            otpMutation.mutate((document.getElementById(idName) as HTMLInputElement)!.value)
        }
    }

    const { code } = useParams();
    const mutation = useMutation({
        mutationFn: SetUserRef,
        onSuccess: data => {
            Cookies.set('refNum', data?.data?.phoneNumber)
            Cookies.set('refName', data?.data?.fullname)
            if (data.statusCode === 400) {
                navigate('/')
                toast.error(data.message, toastOptions)
            }
        },
        onError: () => {
            navigate('/')
            toast.error(errorText, toastOptions)
        },
    });
    useEffect(() => {
        Cookies.remove('refNum');
        Cookies.remove('refName');
        const referralCode = code?.split('=')[1];
        if (referralCode !== undefined) {
            let data = {
                referralCode: referralCode
            }
            mutation.mutate(data)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <>
            {/* swiper */}
            <Swiper
                ref={props.swiperRef}
                direction={'vertical'}
                spaceBetween={10}
                slidesPerView={1}
                pagination={{ clickable: true }}
                mousewheel={true}
                speed={1500}
                modules={[Pagination, Mousewheel]}
                className={'slider-page overflow-hidden'}
                onSlideChange={props.handleSlideChange}
            >
                <SwiperSlide
                    onMouseMove={(e) => Parallax(e, 'object_third')}>
                    {/* content */}
                    <section
                        className={'px-md-5 mb-5 px-2 h-100'}>
                        <div className={'row align-items-end h-100 justify-content-center'}>
                            <div className={'col-md-12 col-11 text-center'}>
                                <img className={'img-fluid'} alt={'logo'}
                                    src={require('../../assets/media/logo/Logo_Iran Tarakonesh_Vr_33_Sefid 1.webp')} />
                                <div className={'row mt-5 justify-content-center'}>
                                    <div className={'col-md-8 col-lg-5 col-12'}>
                                        <div className={'d-flex justify-content-center mt-md-3 mt-4'}>
                                            <input
                                                type={'tel'}
                                                id={'telephone'}
                                                maxLength={11}
                                                className={'w-75 form-control login-input'}
                                                placeholder={'شماره موبایلتون رو وارد کنید...'}
                                            />
                                            <button id={'signup-btn'}
                                                onClick={() => authUser('telephone')}
                                                className={'form-btn login-btn text-black fw-bold font-medium'}>
                                                <svg className={'ms-1'} width="24" height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M18.5 19.5H14.5" stroke="#171717" strokeWidth="2"
                                                        strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M16.5 21.5V17.5" stroke="#171717" strokeWidth="2"
                                                        strokeLinecap="round" strokeLinejoin="round" />
                                                    <path
                                                        d="M11.99 21.81C10.17 21.81 8.36004 21.35 6.98004 20.43C4.56004 18.81 4.56004 16.17 6.98004 14.56C9.73004 12.72 14.24 12.72 16.99 14.56"
                                                        stroke="#171717" strokeWidth="2" strokeLinecap="round"
                                                        strokeLinejoin="round" />
                                                    <path
                                                        d="M15.6801 3.96C16.1601 4.67 16.4401 5.52 16.4401 6.44C16.4301 8.84 14.5401 10.79 12.1601 10.87C12.0601 10.86 11.9401 10.86 11.8301 10.87C9.45006 10.79 7.56006 8.84 7.56006 6.44C7.56006 3.99 9.54006 2 12.0001 2"
                                                        stroke="#171717" strokeWidth="2" strokeLinecap="round"
                                                        strokeLinejoin="round" />
                                                </svg>
                                                ثبت نام
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={'col-12'}>
                                <div
                                    className={'row mt-1 pe-4 justify-content-start w-100'}>
                                    <p className={'text-white font-medium text-center mb-1'}>
                                        اگه می خوای بدونی اینجا چه خبره ، بیا پایین...
                                    </p>
                                    <div className={'col-6 mt-3 px-0 pb-2'}>
                                        <div
                                            className={'card card-body rounded-0 border-opacity-10 border-0 border-start border-animate'}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </SwiperSlide>
                {/* item */}
                <SwiperSlide onMouseMove={(e) => Parallax(e, 'object')}>
                    {/* content */}
                    <section className={'container h-100'}>
                        <div
                            className={'row banner-row h-100 align-items-md-center justify-content-center position-relative'}>
                            <div className={'col-lg-6 col-md-5 col-10'}>
                                <div className={'d-flex align-items-end justify-content-end h-100'}>
                                    <img alt={'phone'}
                                        data-value={'-0.5'}
                                        className={'img-fluid object'}
                                        src={require('../../assets/media/images/banner/Slide_01_PhonePos_Vr_01 1.webp')} />
                                </div>
                            </div>
                            <div className={'col-md-6 col-10 mt-md-0 mt-5 text-center'}>
                                <img alt={'text'}
                                    data-value={'-1'}
                                    className={'img-fluid object'}
                                    src={require('../../assets/media/images/banner/Slide_01_Text_Vr_01.webp')} />
                            </div>
                        </div>
                    </section>
                </SwiperSlide>
                {/* items */}
                <SwiperSlide onMouseMove={(e) => Parallax(e, 'object_second')} className={'position-relative'}>
                    {/* content */}
                    <section className={'container h-100'}>
                        <div
                            className={'row banner-row h-100 align-items-center justify-content-md-start justify-content-center'}>
                            <div
                                className={'col-md-6 mt-md-0 mt-5 mt-page col-10 text-center order-md-0 order-1'}>
                                <img alt={'phone'}
                                    data-value={'-1'}
                                    className={'img-fluid object_second'}
                                    src={require('../../assets/media/images/banner/second.png')} />
                            </div>
                        </div>
                    </section>
                    <img alt={'phone'}
                        className={'img-fluid animate_img position-absolute small-img'}
                        src={require('../../assets/media/images/banner/pos.webp')} />
                    <img alt={'text'}
                        data-value={'-0.5'}
                        className={'img-fluid object_second position-absolute text-img-small'}
                        src={require('../../assets/media/images/banner/hand.webp')} />
                </SwiperSlide>
                {/* items */}
                <SwiperSlide onMouseMove={(e) => Parallax(e, 'object_third')}>
                    {/* content */}
                    <section className={'container h-100'}>
                        <div
                            className={'row banner-row h-100 align-items-md-center justify-content-center position-relative'}>
                            <div className={'col-md-6 col-10'}>
                                <div className={'slider-icon h-100 d-flex align-items-end'}>
                                    <img alt={'phone'}
                                        data-value={'-0.5'}
                                        className={'img-fluid object_third'}
                                        src={require('../../assets/media/images/banner/money.png')} />
                                </div>
                            </div>
                            <div className={'col-md-6 col-10 text-center'}>
                                <img alt={'text'}
                                    data-value={'-1'}
                                    className={'img-fluid object_third'}
                                    src={require('../../assets/media/images/banner/moneyText.png')} />
                                <p className={'fw-bold text-end mt-4 text-red h5 third-title'}>
                                    میدونستی تا پول نشینه به حسابت پرداختشون قطعی نیست؟
                                </p>
                            </div>
                        </div>
                    </section>
                </SwiperSlide>
                <SwiperSlide
                    onTouchStart={props.handleTouchStart}
                    onTouchEnd={props.handleTouchEnd}
                    onWheel={(event) => props.handleWheel(event)}
                    onMouseMove={(e) => Parallax(e, 'object_fourth')}>
                    {/* content */}
                    <section className={'container h-100'}>
                        <div
                            className={'row gx-0 banner-row h-100 align-items-md-center justify-content-center position-relative'}>
                            <div className={'col-md-5 col-10 order-md-0 order-1 text-center'}>
                                <img alt={'text'}
                                    data-value={'-1'}
                                    className={'img-fluid object_fourth'}
                                    src={require('../../assets/media/images/banner/moniesText.png')} />
                            </div>
                            <div className={'col-md-7 col-11 order-md-1 order-0 mb-md-0 mb-3 text-center'}>
                                <div
                                    className={'slider-icon h-100 d-flex justify-content-md-end justify-content-center align-items-end'}>
                                    <img alt={'phone'}
                                        data-value={'-0.5'}
                                        className={'img-fluid object_fourth animate_img'}
                                        src={require('../../assets/media/images/banner/monies.webp')} />
                                </div>
                            </div>
                        </div>
                    </section>
                </SwiperSlide>
            </Swiper>
            <ToastContainer />
        </>
    )
}

export default Slider;